const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/shrink-wrapping-categories`
};

export default apiUrls;
